var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"show-loading":"","loading":_vm.loading}},[_c('create-page',{attrs:{"is-root":"","is-global-f-api":"","root-type":"page","template":_vm.template,"global-params":_vm.requireParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }